<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="first_name"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.first_name"
        :form-state="formState"
        name="first_name"
        :validators="$v.item"
        :input="updateLogin('first_name')"
        :server-errors="_se"
        v-bind="schema.fields.first_name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="last_name"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.last_name"
        :form-state="formState"
        name="last_name"
        :input="updateLogin('last_name')"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.last_name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="code"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.code"
        :form-state="formState"
        name="code"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.code"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="email_address"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        name="email_address"
        v-model="item.email_address"
        :form-state="formState"
        :validators="$v.item"
        :input="updateLogin('email_address', 'email')"
        :server-errors="_se"
        v-bind="schema.fields.email_address"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="phone_number"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.phone_number"
        :form-state="formState"
        name="phone_number"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.phone_number"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="employee_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.employee_type"
        :items="optionCodeEmployeeTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeEmployeeTypeWorking"
        name="employee_type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.employee_type"
        allow-add
        store-name="CodeEmployeeType"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-employee-type-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-employee-type-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="depot"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.depot"
        :items="optionCodeDepotItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeDepotWorking"
        name="depot"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.depot"
        allow-add
        store-name="CodeDepot"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-depot-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-depot-form>
        </template>
      </o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="category"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.category"
        :items="optionCodeEmployeeCategoryItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeEmployeeCategoryWorking"
        name="category"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.category"
        allow-add
        store-name="CodeEmployeeCategory"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-employee-category-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-employee-category-form>
        </template>
      </o-select>
    </o-widget-wrapper>
    <embedded-user-form
      :parent-item="item"
      login-field-name="login"
      :form-state="formState"
      :server-errors="_se.login"
      :parent-mapping="userMapping"
    >
    </embedded-user-form>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import UseCodeModulesMixin from "@/vue-ocom/mixins/UseCodeModulesMixin.js";

// import { default as UserForm } from '../../user/components/ItemForm';
import { default as CodeEmployeeTypeForm } from "../../code_employee_type/components/ItemForm";
import { default as CodeDepotForm } from "../../code_depot/components/ItemForm";
import EmbeddedUserForm from "@/vue-ocom/grouppermissions/user/components/EmbeddedUserForm";

import { default as CodeEmployeeCategoryForm } from "../../code_employee_category/components/ItemForm";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Employee"),
    UseCodeModulesMixin([
      "User",
      "CodeEmployeeType",
      "CodeDepot",
      "CodeEmployeeCategory",
    ]),
  ],
  components: {
    EmbeddedUserForm,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    /* UserForm, */ CodeEmployeeTypeForm,
    CodeDepotForm,
    CodeEmployeeCategoryForm,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Employee, {}),
    userMapping: {
      first_name: "first_name",
      last_name: "last_name",
      username: "code",
      email: "email_address",
    },
  }),
  methods: {
    updateLogin(fieldname, destfieldname) {
      var item = this.item;
      if (item.login) {
        this.item.login[destfieldname || fieldname] = this.item[fieldname];
      }
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
